import React, { useState, useEffect } from "react";
import axios from "axios";
import { LinkContainer } from "react-router-bootstrap";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  ListGroup,
} from "react-bootstrap";
import { AiFillEdit, AiOutlineRollback } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getPassportById,
  resetPassportUpdate,
  resetPassportDetails,
  updatePassport,
} from "../features/passport/passportSlice";
import { getAllOffices } from "../features/deliveryoffice/officeSlice";
import { getAllAgents } from "../features/agent/agentSlice";
import { getAllEmployees } from "../features/employee/employeeSlice";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import Moment from "moment";
import {
  FaFilePdf,
  FaFileWord,
  FaFilePowerpoint,
  FaFile,
  FaDownload,
} from "react-icons/fa";

const UpdatePassport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();

  const {
    passport,

    isDetailsLoading,
    isDetailsError,
    isDetailsSuccess,
    detailsErrorMessage,

    isUpdateLoading,
    isUpdateError,
    isUpdateSuccess,
    updateErrorMessage,
  } = useSelector((state) => state.passport);

  const {
    offices,

    isListLoading,
    isListError,
    isListSuccess,
    listErrorMessage,
  } = useSelector((state) => state.office);

  const {
    agents,
    isListLoading: isAgentListLoading,
    isListError: isAgentListError,
    isListSuccess: isAgentListSuccess,
    listErrorMessage: agentListErrorMessage,
  } = useSelector((state) => state.agent);

  const {
    employees,
    isListLoading: isEmployeeListLoading,
    isListError: isEmployeeListError,
    isListSuccess: isEmployeeListSuccess,
    listErrorMessage: employeeListErrorMessage,
  } = useSelector((state) => state.employee);

  const { userInfo } = useSelector((state) => state.user);

  //Passport States
  const [passportScanCopy, setPassportScanCopy] = useState("");
  const [clientFullName, setClientFullName] = useState("");
  const [clientPassportNumber, setClientPassportNumber] = useState("");
  const [clientPhone, setClientPhone] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientAddress, setClientAddress] = useState("");
  const [clientDob, setClientDob] = useState("");
  const [clientAge, setClientAge] = useState("");
  const [clientDoIssue, setClientDoIssue] = useState("");
  const [clientReceiveDate, setClientReceiveDate] = useState("");
  const [clientCountry, setClientCountry] = useState("");
  const [clientCompany, setClientCompany] = useState("");
  const [post, setPost] = useState("");
  const [clientAgent, setClientAgent] = useState("");
  const [clientOfficeAgent, setClientOfficeAgent] = useState("");
  const [initialContractAmount, setInitialContractAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [clientContractAmount, setClientContractAmount] = useState(0);
  const [clientPaidAmount, setClientPaidAmount] = useState(0);
  // const [clientDueAmount, setClientDueAmount] = useState(
  //   clientContractAmount - clientPaidAmount
  // );
  const [clientDeliveryOffice, setClientDeliveryOffice] = useState("");
  const [clientDeliveryOfficePayment, setClientDeliveryOfficePayment] =
    useState(0);
  const [clientStatus, setClientStatus] = useState("");

  const [clientPaymentError, setClientPaymentError] = useState("");

  const [deliveryOffices, setDeliveryOffices] = useState([]);
  const [allAgents, setAllAgents] = useState([]);
  const [allEmployees, setAllEmployees] = useState([]);

  useEffect(() => {
    if (isDetailsError) {
      toast.error(detailsErrorMessage, { position: "top-center" });
    } else if (isDetailsSuccess) {
      setPassportScanCopy(passport.passportScanCopy);
      setClientFullName(passport.fullName);
      setClientPassportNumber(passport.passportNumber);
      setClientPhone(passport.phone);
      setClientEmail(passport.email);
      setClientAddress(passport.address);
      setClientDob(passport.dateOfBirth);
      setClientAge(Moment().diff(passport.dateOfBirth, "years"));
      setClientDoIssue(passport.doIssueDate);
      setClientReceiveDate(passport.passportReceiveDate);
      setClientCountry(passport.country);
      setClientCompany(passport.company);
      setPost(passport.clientPost);
      setClientAgent(passport.agent);
      setClientOfficeAgent(passport.officeAgent);
      setInitialContractAmount(passport.initialContract !== 0 ? passport.initialContract : passport.contractAmount);
      setDiscount(passport.discount);
      setClientContractAmount(passport.contractAmount);
      setClientPaidAmount(passport.paidAmount);
      // setClientDueAmount(passport.contractAmount - passport.paidAmount);
      setClientDeliveryOffice(passport.deliveryOffice);
      setClientDeliveryOfficePayment(passport.deliveryOfficePayment);
      setClientStatus(passport.status);
    } else {
      dispatch(getPassportById(params.id));
    }
  }, [isDetailsError, detailsErrorMessage, isDetailsSuccess]);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    if (isUpdateError) {
      toast.error(updateErrorMessage, { position: "top-center" });
    } else if (isUpdateSuccess) {
      toast.success("Passport Updated Successfully", {
        position: "top-center",
      });
      navigate("/passportList");
    }
  }, [isUpdateError, updateErrorMessage, isUpdateSuccess]);

  // Delivery Office List
  useEffect(() => {
    if (isListError) {
      // toast.error(listErrorMessage, { position: "top-center" });
    } else if (isListSuccess) {
      // return offices;
      setDeliveryOffices(offices);
    } else {
      dispatch(getAllOffices());
    }
  }, [dispatch, isListError, isListSuccess, offices]);

  // Agents List
  useEffect(() => {
    if (isAgentListError) {
      // toast.error(agentListErrorMessage, { position: "top-center" });
    } else if (isAgentListSuccess) {
      // return offices;
      setAllAgents(agents);
    } else {
      dispatch(getAllAgents());
    }
  }, [
    dispatch,
    isAgentListError,
    isAgentListSuccess,
    // agentListErrorMessage,
    agents,
  ]);

  // Employees List
  useEffect(() => {
    if (isEmployeeListError) {
      // toast.error(employeeListErrorMessage, { position: "top-center" });
    } else if (isEmployeeListSuccess) {
      setAllEmployees(employees);
    } else {
      dispatch(getAllEmployees());
    }
  }, [
    dispatch,
    isEmployeeListError,
    isEmployeeListSuccess,
    // employeeListErrorMessage,
    employees,
  ]);

  useEffect(() => {
    return () => {
      dispatch(resetPassportDetails());
      dispatch(resetPassportUpdate());
    };
  }, [dispatch]);

  const handleDeliveryOfficeSelect = (e) => {
    if (e.target.value !== "") {
      // setSelectedDeliveryOffice(e.target.value);
      setClientDeliveryOffice(e.target.value);
    } else {
      setClientDeliveryOffice("");
    }
  };

  const handleAgentSelect = (e) => {
    if (e.target.value !== "") {
      setClientAgent(e.target.value);
    } else {
      setClientAgent("");
    }
  };

  const handleEmployeeSelect = (e) => {
    if (e.target.value !== "") {
      setClientOfficeAgent(e.target.value);
    } else {
      setClientOfficeAgent("");
    }
  };

  const updateHandler = () => {
    const passportData = {
      passportScanCopy,
      fullName: clientFullName,
      passportNumber: clientPassportNumber,
      phone: clientPhone,
      email: clientEmail,
      address: clientAddress,
      dateOfBirth: clientDob,
      age: clientAge,
      doIssueDate: clientDoIssue,
      passportReceiveDate: clientReceiveDate,
      country: clientCountry,
      company: clientCompany,
      clientPost: post,
      agent: clientAgent,
      officeAgent: clientOfficeAgent,
      initialContract: initialContractAmount,
      discount,
      contractAmount: clientContractAmount,
      paidAmount: clientPaidAmount,
      // dueAmount: clientDueAmount,
      deliveryOffice: clientDeliveryOffice,
      deliveryOfficePayment: clientDeliveryOfficePayment,
      status: clientStatus,
    };
    dispatch(updatePassport({ id: params.id, passportData }));
  };

  // const clientPayCheck = (v) => {
  //   if (v * 1 > clientContractAmount * 1 || v * 1 < 0) {
  //     setClientPaymentError(
  //       "Payment can not be greater than contract amount or less than 0"
  //     );
  //   } else {
  //     setClientPaymentError("");
  //     setClientPaidAmount(v * 1);
  //     setClientDueAmount(clientContractAmount * 1 - v * 1);
  //   }
  // };

  // For existing passports where initial contract amount is 0, set contract amount to initial contract amount
  // useEffect(() => {
  //   if (initialContractAmount === 0) {
  //     setInitialContractAmount(clientContractAmount);
  //   }
  // }, [initialContractAmount]);

  // Calculate contract amount after discount
  useEffect(() => {
    setClientContractAmount(initialContractAmount * 1 - discount * 1);
  }, [initialContractAmount, discount]);

  //Image Upload
  // const uploadImageFileHandler = async (e) => {
  //   const file = e.target.files[0];
  //   const formData = new FormData();
  //   formData.append("image", file);
  //   try {
  //     const config = {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     };

  //     const { data } = await axios.post(
  //       `/api/v1/upload${
  //         passportScanCopy ? `/${passportScanCopy.slice(8)}` : ""
  //       }`,
  //       formData,
  //       config
  //     );
  //     setPassportScanCopy(data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // Upload Document File Handler

  const uploadDocumentFileHandler = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("document", file);
    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post(
        `/api/v1/upload${
          passportScanCopy ? `/${passportScanCopy.slice(8)}` : ""
        }`,
        formData,
        config
      );
      setPassportScanCopy(data);
    } catch (error) {
      console.error(error);
    }
  };

  let fileIcon = null;
  let documentType = null;

  const extension = passportScanCopy.split(".").pop().toLowerCase();

  if (extension === "pdf") {
    documentType = "PDF";
    fileIcon = <FaFilePdf size={50} style={{ color: "red" }} />;
  } else if (extension === "doc" || extension === "docx") {
    documentType = "DOC";
    fileIcon = <FaFileWord size={50} style={{ color: "blue" }} />;
  } else {
    documentType = "Other";
    fileIcon = <FaFile size={50} />;
  }
  let downloadLink = null;
  downloadLink = passportScanCopy ? `${passportScanCopy}` : null;

  return (
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []),
    (
      <>
        {isDetailsLoading || isUpdateLoading ? (
          <Loader />
        ) : isDetailsError ? (
          <h4 variant="danger">{detailsErrorMessage}</h4>
        ) : (
          <Container fluid className="my-4">
            <h2 style={{ fontWeight: "bold " }} className="mb-4 text-center">
              Update Passport
            </h2>

            <Form>
              <Row>
                {/* Column for Upload Files  */}
                <Col sm={12} md={4} lg={3}>
                  <Card className="mb-4 shadow rounded">
                    <Card.Header
                      as="h5"
                      className="text-black p-3 fw-bold text-center"
                      style={{ backgroundColor: "#74a2e3" }}
                    >
                      Document Details
                    </Card.Header>
                    <Card.Body className="text-center">
                      <ListGroup variant="flush">
                        <Card.Body className="text-center">
                          <ListGroup variant="flush">
                            <ListGroup.Item>
                              <div>{fileIcon}</div>

                              <div className="mt-3">
                                <h6>Document Type: {documentType}</h6>
                              </div>
                            </ListGroup.Item>
                          </ListGroup>
                        </Card.Body>
                        {downloadLink && (
                          <div>
                            <a
                              href={downloadLink}
                              download
                              style={{ textDecoration: "none" }}
                            >
                              <FaDownload size={20} /> Download
                            </a>
                          </div>
                        )}
                      </ListGroup>
                    </Card.Body>
                  </Card>

                  <Card className="mb-4 shadow rounded">
                    <Card.Header
                      as="h5"
                      className="text-black p-3 fw-bold text-center"
                      style={{ backgroundColor: "#74a2e3" }}
                    >
                      Upload New Document
                    </Card.Header>
                    <Card.Body className="text-center">
                      <ListGroup variant="flush">
                        <ListGroup.Item>
                          <Form.Group controlId="document">
                            <Form.Label className="py-3">
                              Upload File
                            </Form.Label>
                            <Form.Control
                              className="mb-3 rounded"
                              type="file"
                              id="document-file"
                              label="Pasport Scan Copy"
                              controlId="passportScanCopy"
                              onChange={uploadDocumentFileHandler}
                            ></Form.Control>
                          </Form.Group>

                          <div className="small font-italic text-muted ">
                            doc, docx, pdf
                          </div>
                        </ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Column For Form */}
                <Col sm={12} md={8} lg={9}>
                  <Card className="mb-4 shadow rounded">
                    <Card.Header
                      as="h5"
                      className="text-black p-3 fw-bold text-center"
                      style={{ backgroundColor: "#74a2e3" }}
                    >
                      Update Passport Information
                    </Card.Header>

                    <Card.Body className="fw-bold">
                      <Row>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="Name">
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control
                              required
                              type="text"
                              placeholder={
                                clientFullName === ""
                                  ? "Full Name is Required"
                                  : "Enter Full Name"
                              }
                              value={clientFullName}
                              onChange={(e) =>
                                setClientFullName(e.target.value)
                              }
                            ></Form.Control>
                          </Form.Group>
                        </Col>

                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="PassportNumber">
                            <Form.Label>Passport Number</Form.Label>
                            <Form.Control
                              required
                              type="text"
                              placeholder={
                                clientPassportNumber === ""
                                  ? "Passport Number is Required"
                                  : "Enter Passport Number"
                              }
                              value={clientPassportNumber}
                              onChange={(e) =>
                                setClientPassportNumber(e.target.value)
                              }
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="Phone">
                            <Form.Label>Phone</Form.Label>
                            <Form.Control
                              required
                              type="text"
                              placeholder={
                                clientPhone === ""
                                  ? "Phone Number is Required"
                                  : "Enter Phone Number"
                              }
                              value={clientPhone}
                              onChange={(e) => setClientPhone(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="Email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              required
                              type="mail"
                              placeholder={
                                clientEmail === ""
                                  ? "Email Address is Required"
                                  : "Enter Email Address"
                              }
                              value={clientEmail}
                              onChange={(e) => setClientEmail(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col sm={12} md={12} lg={12}>
                          <Form.Group controlId="Address">
                            <Form.Label>Address</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={
                                clientAddress === ""
                                  ? "Your Address is Required"
                                  : "Enter Your Address"
                              }
                              value={clientAddress}
                              onChange={(e) => setClientAddress(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="DOB">
                            <Form.Label>Date Of Birth</Form.Label>
                            <Form.Control
                              disabled
                              type="text"
                              placeholder={"Please Enter Date Of Birth"}
                              value={Moment(clientDob).format("DD.MM.YYYY")}
                              // onChange={(e) => calculateDob(e.target.value)}
                            ></Form.Control>
                            <Form.Control
                              type="date"
                              placeholder={clientDob === ""}
                              value={clientDob}
                              onChange={(e) => setClientDob(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="Age">
                            <Form.Label>Age</Form.Label>
                            <Form.Control
                              type="number"
                              disabled
                              placeholder={clientAge === ""}
                              value={clientAge}
                              onChange={(e) => setClientAge(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="DOissue">
                            <Form.Label>DO Issue</Form.Label>
                            <Form.Control
                              disabled
                              required
                              type="text"
                              placeholder={
                                clientDoIssue === ""
                                  ? "Please Enter Date Of Issue"
                                  : clientDoIssue
                              }
                              value={Moment(clientDoIssue).format("DD.MM.YYYY")}
                              // onChange={(e) => setClientDoIssue(e.target.value)}
                            ></Form.Control>
                            <Form.Control
                              required
                              type="date"
                              placeholder={clientDoIssue === ""}
                              value={clientDoIssue}
                              onChange={(e) => setClientDoIssue(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="ReceiveDate">
                            <Form.Label>Receive Date</Form.Label>
                            <Form.Control
                              disabled
                              required
                              type="text"
                              placeholder={
                                clientReceiveDate === ""
                                  ? "Please Enter Date Of Receive"
                                  : clientReceiveDate
                              }
                              value={Moment(clientReceiveDate).format(
                                "DD.MM.YYYY"
                              )}
                              // onChange={(e) =>
                              //   setClientReceiveDate(e.target.value)
                              // }
                            ></Form.Control>
                            <Form.Control
                              required
                              type="date"
                              placeholder={clientReceiveDate === ""}
                              value={clientReceiveDate}
                              onChange={(e) =>
                                setClientReceiveDate(e.target.value)
                              }
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col sm={12} md={4} lg={4}>
                          <Form.Group controlId="Country">
                            <Form.Label>Country</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={clientCountry === ""}
                              value={clientCountry}
                              onChange={(e) => setClientCountry(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={4} lg={4}>
                          <Form.Group controlId="Company">
                            <Form.Label>Company</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={clientCompany === ""}
                              value={clientCompany}
                              onChange={(e) => setClientCompany(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={4} lg={4}>
                          <Form.Group controlId="Post">
                            <Form.Label>Post</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder={post === ""}
                              value={post}
                              onChange={(e) => setPost(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="clientAgent">
                            <Form.Label>Select Agent</Form.Label>
                            <Form.Control
                              className="rounded"
                              as="select"
                              type="select"
                              value={clientAgent}
                              onChange={(e) => handleAgentSelect(e)}
                            >
                              <option disabled value="">
                                Select Agent
                              </option>

                              {allAgents.map((agent) => (
                                <option key={agent._id} value={agent.fullName}>
                                  {agent.fullName}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                        </Col>

                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="clientOfficeAgent">
                            <Form.Label>Select Employee</Form.Label>
                            <Form.Control
                              className="rounded"
                              as="select"
                              type="select"
                              // placeholder={clientOfficeAgent === ""}
                              value={clientOfficeAgent}
                              onChange={(e) => handleEmployeeSelect(e)}
                            >
                              <option disabled value="">
                                Select Employee
                              </option>
                              {allEmployees.map((employee) => (
                                <option
                                  key={employee._id}
                                  value={employee.fullName}
                                >
                                  {employee.fullName}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col sm={12} md={4} lg={4}>
                          <Form.Group controlId="Contract">
                            <Form.Label>Initial Contract Amount</Form.Label>
                            <Form.Control
                              required
                              type="number"
                              placeholder="Initial Contract Amount"
                              value={initialContractAmount}
                              onChange={(e) => {
                                setInitialContractAmount(e.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={4} lg={4}>
                          <Form.Group controlId="Contract">
                            <Form.Label>Discount Amount</Form.Label>
                            <Form.Control
                              // required
                              type="number"
                              placeholder="Discount Amount"
                              value={discount}
                              onChange={(e) => {
                                setDiscount(e.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={4} lg={4}>
                          <Form.Group controlId="Contract">
                            <Form.Label>Contract Amount</Form.Label>
                            <Form.Control
                              // required
                              disabled
                              type="number"
                              placeholder="Will Be Updated Automatically"
                              value={clientContractAmount}
                              onChange={(e) => {
                                setClientContractAmount(e.target.value);
                                // setClientDueAmount(
                                //   e.target.value * 1 - clientPaidAmount * 1
                                // );
                              }}
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        {/* <Col sm={12} md={4} lg={4}>
                          <Form.Group controlId="AmountPaid">
                            <Form.Label>Amount Paid</Form.Label>
                            <Form.Control
                              required
                              type="number"
                              // placeholder={clientPaidAmount === ""}
                              value={
                                clientPaymentError !== ""
                                  ? ""
                                  : clientPaidAmount
                              }
                              onChange={(e) => clientPayCheck(e.target.value)}
                            ></Form.Control>
                          </Form.Group>
                        </Col> */}
                        {/* <Col sm={12} md={4} lg={4}>
                          <Form.Group controlId="DueAmount">
                            <Form.Label>Amount Due</Form.Label>
                            <Form.Control
                              // required
                              disabled
                              type="text"
                              placeholder={
                                "Due Amount Will Be Calculated Automatically"
                              }
                              value={clientDueAmount}
                              onChange={(e) =>
                                setClientDueAmount(e.target.value)
                              }
                            ></Form.Control>
                          </Form.Group>
                        </Col> */}
                      </Row>
                      <Row className="mt-3">
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="DeliveryOffice">
                            <Form.Label>Delivery Office</Form.Label>
                            <Form.Control
                              className="rounded"
                              required
                              as="select"
                              type="select"
                              placeholder={clientDeliveryOffice === ""}
                              value={clientDeliveryOffice}
                              onChange={(e) => handleDeliveryOfficeSelect(e)}
                            >
                              <option disabled value="">
                                Select Delivery Office
                              </option>
                              {deliveryOffices.map((office) => (
                                <option
                                  key={office._id}
                                  value={office._officeName}
                                >
                                  {office.officeName}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                          <Form.Group controlId="DeliveryOfficePyment">
                            <Form.Label>Delivery Office Payment</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder={clientDeliveryOfficePayment === ""}
                              value={clientDeliveryOfficePayment}
                              onChange={(e) =>
                                setClientDeliveryOfficePayment(e.target.value)
                              }
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col sm={12} md={12} lg={12}>
                          <Form.Group controlId="status">
                            <Form.Label>Status</Form.Label>
                            <Form.Control
                              required
                              as="select"
                              value={clientStatus}
                              onChange={(e) => setClientStatus(e.target.value)}
                            >
                              <option value="" disabled>
                                Select Status
                              </option>
                              <option value="Pending">Pending</option>
                              <option value="Processing">Processing</option>
                              <option value="Completed">Completed</option>
                              <option value="Delivered">Delivered</option>
                              <option value="Returned">Returned</option>
                              <option value="Flight Completed">
                                Flight Completed
                              </option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mt-4">
                        <Col sm={12} md={6} lg={6} className="px-4">
                          <Row>
                            <Button
                              variant="outline-primary"
                              type="submit"
                              className="rounded"
                              onClick={updateHandler}
                            >
                              <AiFillEdit className="mb-1" size={18} />
                              Update Passport
                            </Button>
                          </Row>
                        </Col>

                        <Col sm={12} md={6} lg={6} className="px-4">
                          <Row>
                            <LinkContainer to={`/passportList`}>
                              <Button
                                variant="outline-secondary"
                                className="rounded"
                              >
                                <AiOutlineRollback className="mb-1" size={18} />
                                Back To List
                              </Button>
                            </LinkContainer>
                          </Row>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          </Container>
        )}
      </>
    )
  );
};

export default UpdatePassport;
